<template>
  <div>
    <div class="index-container transitionBody activity-page">
      <div class="activity">
        <div class="hall-head_box">
          <div class="hall-head">
            优惠活动
            <div class="xzimg"></div>
            <div class="xxbox" @click="$parent.openKefu()"><!----></div>
          </div>

          <div data-v-730dfc06="" class="navcontent">
            <div data-v-730dfc06="" class="navbars">
                <div data-v-730dfc06="" @click="changActType('')" :class="{active:actType===''}" class="navbar"> 全部优惠 </div>
                <div data-v-730dfc06="" v-for="item in activityTypeShown" :key="item.id"
                     @click="changActType(item.id)" :class="{active:actType==item.id}" class="navbar"> {{ item.name }} </div>
            </div>
        </div>

        </div>

        <!----><!---->
        <div class="activecont">
          <div class="activeinner">
            <div class="PulldownRefresh">
              <div class="van-pull-refresh">
                <div class="van-pull-refresh__track" style="transition-duration: 0ms">
                  <div class="van-pull-refresh__head" style="height: 80px"></div>
                  <div class="main_content">
                    <!-- 首存 banner：只在“全部优惠”下展示 -->
                    <div class="activebox" v-if="actType==='' && firstDepositImg" @click="$parent.openKefu()">
                      <img :src="firstDepositImg" />
                    </div>

                    <!-- 后台配置的活动列表 -->
                    <div class="act_item" v-for="item in activitylistList" :key="item.id" @click="goDetail(item)">
                      <img class="act_img" :src="resolveBanner(item.banner)" alt="" />
                      <div class="act_meta">
                        <div class="act_txt">
                          <div class="act_name">{{ item.title }}</div>
                          <div class="act_desc" v-if="item.entitle">{{ item.entitle }}</div>
                        </div>
                        <div class="act_count">{{ item.apply_count || 0 }}人已申请</div>
                      </div>
                    </div>

                    <!-- 空状态 -->
                    <div data-v-730dfc06="" class="expectation" v-if="!loading && activitylistList.length===0">
                      <img data-v-730dfc06="" src="/static/img/expectation.ccc42cce.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!---->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
      loading: false,
      firstDepositImg: '/static/image/activity_usdt_banner.jpeg',
      defaultActivityBanner: '/static/image/activity_usdt_banner.jpeg',
    };
  },
  computed: {
    // 只展示后台启用中的活动分类
    activityTypeShown() {
      return (this.activitytypeList || []).filter(item => item && (item.state == 1 || item.state === undefined));
    },
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
    that.getFirstDepositImg();
  },
  methods: {
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        if (res.code === 200) {
          that.activitytypeList = res.data || [];
        }
      });
    },
    getFirstDepositImg() {
      let that = this;
      that.$apiFun.post('/api/bannerList', { type: 2 }).then(res => {
        if (res.code == 200 && res.data && res.data.length && res.data[0].src) {
          that.firstDepositImg = res.data[0].src;
        }
      });
    },
    // 后台有活动只填了目录（https://api.1919c.top/uploads/）时视为没有封面
    validBanner(url) {
      if (!url) return '';
      if (/\/uploads\/?$/.test(url)) return '';
      return url;
    },
    resolveBanner(url) {
      return this.validBanner(url) || this.defaultActivityBanner;
    },
    activitylist() {
      let that = this;
      let info = that.actType === '' ? {} : { type: that.actType };
      that.loading = true;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        if (res.code !== 200) {
          that.activitylistList = [];
          that.$parent.showTost(0, res.message);
        } else {
          let d = res.data || {};
          that.activitylistList = d.data || (Array.isArray(d) ? d : []);
        }
        that.loading = false;
        that.$parent.hideLoading();
      }).catch(() => {
        that.activitylistList = [];
        that.loading = false;
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
    goDetail(item) {
      this.$parent.goNav('/activityInfo?id=' + item.id);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.activity {
  width: 100%;
  background-color: #f5f7fb;
  height: 100%;
  overflow: hidden;
}
.activity-page {
  background: #f5f7fb;
}
.activity div::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
.activity .colosline {
  width: 100%;
  height: 0.08rem;
  background: -webkit-linear-gradient(left, #f08448, #ffce70, #f08449);
  background: linear-gradient(90deg, #f08448, #ffce70, #f08449);
}
.activity .backhead {
  width: 100%;
  height: 1.17333rem;
  border-bottom: 0.02667rem solid #f6f6f6;
  font-size: 0.45333rem;
  color: #424653;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  background: #fff;
}
.activity .backhead img {
  width: 0.64rem;
  height: 0.64rem;
  position: absolute;
  left: 0.26667rem;
  top: 0.26667rem;
}
.activity .hall-head {
  
  box-sizing: border-box;
  height: 1.17333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
  font-size: 0.50667rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #424653;
}
.hall-head_box{
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  box-shadow: 0 8px 22px rgba(38, 58, 90, 0.08);
}
.activity .hall-head .xzimg {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAZlBMVEUAAABeYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm1eYm2tmYJeYm2tmYKtmYJeYm1eYm2tmYKtmYKtmYKtmYKtmYKtmYJeYm2tmYKpvTjFAAAAIHRSTlMACfTaWBzKw66eknRNRzg0LHxbH86EjQrc3t2taUcrGOUgPYIAAAE/SURBVDjLpZXrkoIwDIXTAIKCeAEB7/D+L7mkrJs2kaKz5wcztN805CQN4MuUedYhdlleGpjXdtU7Wm1nsBh7IYxBK4n6N4oqddy0kRaJsd+aFOm0Ig492MX1Hhzt13bxoLkdCO0keaT3jQEls6Gd4+u1orcTvNWJ9l4ZRXQezIjO7JyEZ+tgODjKPHRGaOtGvgCrGUgNL5BLVE2qr+vfMMnxk+o+fUMKIRBSm0M5PoswWIxICfn4TMJgMiI5ZOyNBtmhzLoNYRCo3wAdsB581QyiBz4F+HRAP/TD4x5uaJHM3eHuXjLSntsfdxP2SMObX64RhusSXi13lSXUTQE1G8NNwW3Gai/DpQXdZrpx27qVjfvpVYg/vFzRl9d1eQB8M1I4wvKQ4uh67HFcVhUapMuj+T/Dnn8fZ8Sz/n38ADWZQnzOMijZAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
  right: 1.61333rem;
}
.activity .hall-head .kefuicon,
.activity .hall-head .xzimg {
  width: 0.53333rem;
  height: 0.53333rem;
  margin-top: 0.08rem;
  position: absolute;
  top: 0.29333rem;
}
.activity .hall-head .kefuicon {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAilBMVEUAAABdYm1eYm1eYm1eYm1paXBeYm1bZm5eYm1dYW1dYm5dYm5dY3BeYm1dYm1eYm1eYm3xjlZeYm3xjlbxj1byjlZeYmxeYW1dY21eYmxeYm3rj1FeYm1eYm1eYm1eYm5gYG9eYW5hYWnxjlZeYm3xjlXwjlZfYm3yjlfyjFXxjlVdYm5eYm3xjlZfMdjrAAAALHRSTlMA8Pv1ygbqEp14HxsNxaukXNvTz6yXb2NRTEYM5JOAODMlCfezs56MTzwSawcR0WQAAAFYSURBVDjLxZNZtoMgEEQRRY1TYtQ4a+bp4f639+g4HUSif6mPHC1ubLqgES+Slq6Ose6WKUFyOZVOB+mVI+OygnIqsnluQwVt5JxqJhYhVrJVZWRCQVu7f7e9j5FMOQPawH9CCd2YgA9w45nNPCbBqFAXTXSFTfMh7aCwPQVPmNk7ztoyx0OCPKHOfvirUGjPOQpzLBG0YJNDMCajQEQESbuimAZ71mgnNKN+TSPoQBdB0AFp60ANqZ82voHIhpY65BvYZvJDcHUzfDz+7Zm3RP68+Vw8Y+AF86OmaYIwisKAPURc4MMR4hS+A0CnIOeOsLsUundEoHfYc+GbvZ7HSyHodfcvF//+aq84jJfIzF9cdw0Io1Cu4GwYrmwFaHIjI1cGHafLXA1HbEqXjxpm6Wu1U2Fo+SzjjG4kVRV+r1IOxXSUEoOzCO43DhhLpZUTZ0ubceup/w/07lIHQOGMRwAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 100% 100%;
  right: 1.34667rem;
}
.activity .hall-head .xxbox {
  width: 0.53333rem;
  height: 0.53333rem;
  margin-top: 0.08rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAkFBMVEUAAADyjlVeYm1cX2rxjVX1hE5fYm5eYW1eYm1dYWxcXmlRVWReYW1eYmxdYm3xjlZdYm1eYm1cYWxeYm3yjlVdYWxdYm1dYW1dYm1dYW1dYm1eYmxdYmxdYW1dYWxdYWxbYGpeZG9aYGteYWxdYm1eYWzxjlVeYm3xjlVeYW3xjVVcYWtbYW1bYGxeYm3xjlbDgLzLAAAALnRSTlMA6/cRjAaqj4I8Fwiwevvv6N1Q7o+L6+LSrKB01tVeVjMuH6aSaZNB8suSSiotIcUsigAAAbJJREFUOMuFVWljgjAMDeC470u5D3XOY93//3drSh0WpHsfIE2ebV8SIoiwvKJJfD9pCs+CTdjmnrxgb9pvadpJJQuoJ23Ni3PyBnm85BlTIDK6h+aA9uiMaPIYAs0pmLOwBGHu5HRgho6eeqXTqtGvL87VHVjBKYXTY1yV8BYZxrgiLaS2CxvAPUNt+tFkbsBpaDhj9cA8t7AJCzOPNTKpcQAJMEsmfWNizwDyLSOAgb58DWTArQao6PMKUmCaK1YUQ07sWHkO/IofO0VJP7ixE4yByU145nc/FJ9PY0eNFI0bVoRSEvDp80JXAbq/qKGgoTw9AVCgXka8Y1xOVAEbu3s9OhWORo+Drc7EeHj1VAluopg0CJi8kYnRmXYpLKSwhIdy4pklfCBctrwrhqmSRxlPU1lTgIdZGiXEisu1VfmWds4bF46U2MhvmDGr5h28hvhFjSj7W8Yj8V+W6i3BLvIM4dvps/1xod1pQ+S5fJVgV5gRutTSmmmjN41Vl4+aCxEQ6l57j1uvrMli7JlEhnAepKen71rKR3OP4URv7X+HfW+Y1ryo8O9DzQ+614OAX3aDW0yTQtmhAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 0.53333rem;
  top: 0.29333rem;
}
.activity .hall-head .xxbox font {
  width: 0.16rem;
  height: 0.16rem;
  border-radius: 50%;
  background: #f18e56;
  position: absolute;
  top: -0.08rem;
  right: -0.08rem;
}
.activity .navcontent {
  float: left;
  width: 100%;
  height: 1.06667rem;
  background: #fff;
  overflow-y: hidden;
  overflow-x: scroll;
  margin-bottom: 0.26667rem;
}
.activity .navcontent .navbars {
  width: auto;
  height: 0.81333rem;
  margin-top: 0.18667rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  white-space: nowrap;
}
.activity .navcontent .navbars .navbar {
  padding: 0.13333rem 0.32rem;
  margin-left: 0.26667rem;
  color: #8f98aa;
  font-size: 0.33333rem;
  font-weight: 500;
  text-align: center;
  border-radius: 0.42667rem;
  background: #f3f5fb;
  transition: all 0.2s ease;
}
.activity .navcontent .navbars .active {
  color: #fff;
  background: linear-gradient(135deg, #5f83ff, #6aabff);
  box-shadow: 0 8px 18px rgba(95, 131, 255, 0.22);
}
.activity .activecont {
  width: 100%;
  padding-top: 2.4rem;
  height: calc(100% - 3.65333rem);
  padding-bottom: 1rem;
  overflow-x: hidden;
  overflow-y: scroll;
}
.activity .activecont .activeinner {
  width: 100%;
  padding: 0.4rem 0.4rem 0.26667rem 0.4rem;
  padding-top: 0 !important;
}
.activity .activecont .activeinner .activebox {
  overflow: hidden;
  width: 9.2rem;
  height: 3.86667rem;
  margin-top: 0.2rem;
  position: relative;
  border-radius: 0.32rem;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(31, 45, 61, 0.08);
}
.activity .activecont .activeinner .activebox img {
  width: 9.2rem;
  height: 3.86667rem;
  display: block;
  object-fit: cover;
}
.activity .activecont .activeinner .activebox:first-child {
  margin-top: -0.13333rem;
}
.act_item {
  width: 9.2rem;
  margin-top: 0.26667rem;
  border-radius: 0.32rem;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 30px rgba(31, 45, 61, 0.08);
  cursor: pointer;
}
.act_item .act_img {
  display: block;
  width: 9.2rem;
  height: 3.86667rem;
  object-fit: cover;
}
.act_item .act_meta {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.24rem 0.32rem 0.28rem;
  gap: 0.2rem;
}
.act_item .act_txt {
  flex: 1;
  min-width: 0;
}
.act_item .act_name {
  font-size: 0.36rem;
  font-weight: 600;
  color: #424653;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.act_item .act_desc {
  margin-top: 0.08rem;
  font-size: 0.28rem;
  color: #98a2b3;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.act_item .act_count {
  font-size: 0.26rem;
  color: #6a8dff;
  white-space: nowrap;
  background: rgba(106, 141, 255, 0.1);
  border-radius: 0.4rem;
  padding: 0.08rem 0.18rem;
}
.activity .activecont .activeinner .expectation {
  padding-top: 0.4rem;
}
.activity .activecont .activeinner .expectation img {
  width: 92%;
}
.activity .contentsds {
  width: 100%;
  height: calc(100% - 1.17333rem);
  overflow-x: hidden;
  overflow-y: scroll;
}
.activity .contentsds .contentsdsinner {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue